import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

import { EmployeeChangeLog } from '../typescript-types/employee-change-log';

export type EmployeeChangeLogState = {
  employeeChangeLogsById: { [employeeChangeLogId: number]: EmployeeChangeLog };
  employeeChangeLogsStateByEmployeeId: StateDictionary;
};
type State = { employeeChangeLogs: EmployeeChangeLogState };

const employeeChangeLogsByIdSelector = (state: State) =>
  state.employeeChangeLogs.employeeChangeLogsById;
export const employeeChangeLogsForEmployeeIdSelector = createSelector(
  [employeeChangeLogsByIdSelector, (_state: State, employeeId: number) => employeeId],
  (employeeChangeLogsById, employeeId) =>
    Object.values(employeeChangeLogsById).filter(
      (changeLog) => changeLog.employeeId === employeeId,
    ),
);

const employeeChangeLogsStateByEmployeeIdSelector = (state: State) =>
  state.employeeChangeLogs.employeeChangeLogsStateByEmployeeId;
export const employeeChangeLogsStateForEmployeeIdSelector = createSelector(
  [employeeChangeLogsStateByEmployeeIdSelector, (_state: State, employeeId: number) => employeeId],
  (employeeChangeLogsStateByEmployeeId, employeeId) =>
    employeeChangeLogsStateByEmployeeId[employeeId],
);
